module.exports = __webpack_public_path__ + "img/GL.73ae82a7.svg";